import { Container, Divider } from "@material-ui/core";
import { Box, Grid, Typography } from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  AutoCompleteWithSearch,
  ButtonGroupTop,
  CurrencyDisplay,
  CustomTable,
  FormCard,
  FormLabel,
  ImportDocumentModal,
  ModalError,
  ModalSuccess,
  MultipleSelectInput,
  Page,
  PrimaryButton,
  SearchTextInput,
  SelectInput,
  StatusChip,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import {
  arrayToCommaSeparatedString,
  createAllFilterOption,
  formatSort,
  getErrors,
  handleChangeFilterAll,
} from "utils";
import InformationCard from "./Components/InformationTable";
import ModalAgreementPotentialClaim from "./Components/ModalAgreementPotentialClaim";
import ModalPreviewPotentialClaim from "./Components/ModalPreviewPotentialClaim";
const PotentialClaim = () => {
  const classes = globalStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const skipNextPreviewRef = useRef(false);
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const pageTitle = "Potential Claim";

  const [pageDetail, setPageDetail] = useState({});
  const [loadingPage, setLoadingPage] = useState(false);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
    dsp_id: 0,
    header_ids: "",
    matching_key: 0,
    sort: "",
  });
  const [dataTable, setDataTable] = useState([]);
  const [tablePageCount, setTablePageCount] = useState(1);
  const [optionDSP, setOptionDSP] = useState([]);
  const [optionProcessInfo, setOptionProcessInfo] = useState([]);
  const [selectedProcessInfo, setSelectedProcessInfo] = useState([]);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [loadingChildrenTable, setLoadingChildrenTable] = useState(false);
  const [queryParamsChildren, setQueryParamsChildren] = useState({
    page: 1,
    size: 10,
    song_id: 0,
    sort: "",
  });
  const [dataTableChildren, setDataTableChildren] = useState([]);
  const [tablePageCountChildren, setTablePageCountChildren] = useState(1);
  const [selectedSong, setSelectedSong] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [loadingDownloadButton, setLoadingDownloadButton] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [cloudFiles, setCloudFiles] = useState([]);
  const [filterParamsPeriod, setFilterParamsPeriod] = useState({
    page: 1,
    size: 10,
    dsp_id: 0,
  });
  const [hasMorePeriod, setHasMorePeriod] = useState(false);
  const [filterParamsDSP, setfilterParamsDSP] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const [hasMoreDSP, setHasMoreDSP] = useState(false);
  const [modalPreviewVisible, setModalPreviewVisible] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [previewDetails, setPreviewDetails] = useState({});
  const [tablePreviewPageCount, setTablePreviewPageCount] = useState(1);
  const [queryParamsPreview, setQueryParamsPreview] = useState({
    page: 1,
    per_page: 100,
    search: "",
    sort: "",
    corrections: [],
  });
  const selectedSongRef = useRef(selectedSong);
  const paramsRef = useRef(queryParamsPreview);
  const previewParamsRef = useRef(queryParamsPreview);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeQueryParamsChildren = (value, key) => {
    setQueryParamsChildren(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeFilterParamsPeriod = (value, key) => {
    setFilterParamsPeriod(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeFilterParamsDSP = (value, key) => {
    setfilterParamsDSP(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const handleChangeFilterProcessInfo = (event, option) => {
    const { checked } = event?.target || false;
    setSelectedProcessInfo(
      handleChangeFilterAll({
        selectedList: selectedProcessInfo,
        checked,
        option,
        key: "header_ids",
        list: optionProcessInfo,
        handleChangeQueryParams,
      })
    );
  };
  const handleSelectSong = (event, option) => {
    const { checked } = event?.target || {};
    skipNextPreviewRef.current = true;
    setSelectedSong(prev => {
      if (checked) {
        const exist = prev.find(item => item.song_id === option.song_id);

        if (exist) return prev;

        return [
          ...prev,
          {
            song_id: option.song_id,
            selected_record_ids: [],
            not_selected_record_ids: [],
          },
        ];
      }
      return prev.filter(item => item.song_id !== option.song_id);
    });
  };
  const handleSelectChildSong = async (event, option) => {
    const { checked } = event?.target || {};
    const parentSongId = queryParamsChildren?.song_id;
    skipNextPreviewRef.current = true;
    setSelectedSong(prev => {
      const index = prev.findIndex(item => item.song_id === parentSongId);
      if (index === -1) {
        if (!checked) return prev;
        return [
          ...prev,
          {
            song_id: parentSongId,
            selected_record_ids: [option.id],
            not_selected_record_ids: [],
          },
        ];
      }
      const updated = [...prev];
      const parent = { ...updated[index] };
      const isSelectAllMode = parent.selected_record_ids.length === 0;

      if (isSelectAllMode) {
        if (!checked) {
          if (!parent.not_selected_record_ids.includes(option.id)) {
            parent.not_selected_record_ids.push(option.id);
          }
        } else {
          parent.not_selected_record_ids = parent.not_selected_record_ids.filter(
            id => id !== option.id
          );
        }
      } else {
        if (checked) {
          if (!parent.selected_record_ids.includes(option.id)) {
            parent.selected_record_ids.push(option.id);
          }
        } else {
          parent.selected_record_ids = parent.selected_record_ids.filter(
            id => id !== option.id
          );
        }
      }

      const isEmptySelected = parent.selected_record_ids.length === 0;
      const isEmptyNotSelected = parent.not_selected_record_ids.length === 0;

      if (isEmptySelected && isEmptyNotSelected) {
        return prev.filter(item => item.song_id !== parentSongId);
      }

      updated[index] = parent;
      return updated;
    });
  };
  const resetFilter = () => {
    setQueryParams({
      page: 1,
      size: 10,
      search: "",
      dsp_id: 0,
      header_ids: "",
      matching_key: 0,
      sort: "",
    });
    setFilterParamsPeriod({
      page: 1,
      size: 10,
      dsp_id: 0,
    });
    setOptionProcessInfo([]);
    setSelectedProcessInfo([]);
  };
  const handleCloseModalPreview = () => {
    setModalPreviewVisible(false);
    setQueryParamsPreview({
      page: 1,
      per_page: 100,
      search: "",
      corrections: [],
    });
  };

  const getDetail = async () => {
    const { matching_key, sort, ...restQuery } = queryParams;
    try {
      const res = await axios.get(`${hardBaseUrl}/potential-claim/summary`, {
        headers,
        params: {
          ...restQuery,
          matching_key: matching_key === 0 ? "" : matching_key,
          sort: formatSort(sort),
        },
      });
      setPageDetail(res?.data?.data);
    } catch (error) {
      ModalError(getErrors(error));
    }
  };
  const getDataTable = async () => {
    const { matching_key, sort, ...restQuery } = queryParams;

    try {
      const res = await axios.get(
        `${hardBaseUrl}/potential-claim/matched-songs`,
        {
          headers,
          params: {
            ...restQuery,
            matching_key: matching_key === 0 ? "" : matching_key,
            sort: formatSort(sort),
          },
        }
      );
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTablePageCount(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error));
    }
  };
  const debounceDataTable = useCallback(
    debounce(async () => {
      setLoadingPage(true);
      await getDataTable();
      await getDetail();
      setLoadingPage(false);
    }, 500),
    [queryParams]
  );
  const getDataChildrenTable = async () => {
    setLoadingChildrenTable(true);
    const { dsp_id, header_ids, matching_key } = queryParams;
    const { sort, ...restChildrenParams } = queryParamsChildren;
    try {
      const res = await axios.get(
        `${hardBaseUrl}/potential-claim/group-suggestions`,
        {
          headers,
          params: {
            ...restChildrenParams,
            matching_key: matching_key === 0 ? "" : matching_key,
            dsp_id,
            header_ids,
            sort: formatSort(sort),
          },
        }
      );
      const { data, meta } = res?.data;
      setDataTableChildren(data || []);
      const pageCount = getTotalPage(meta?.total, queryParamsChildren?.size);
      setTablePageCountChildren(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setLoadingChildrenTable(false);
    }
  };
  const getOptionDSP = async () => {
    setLoadingFilter(true);
    try {
      const res = await axios.get(`${hardBaseUrl}/potential-claim/dsps`, {
        headers,
        params: filterParamsDSP,
      });
      const { data, meta } = res?.data;
      const newOptions = data?.map(item => ({
        ...item,
        id: item?.dsp_id,
      }));
      setOptionDSP(prev => {
        const combined =
          filterParamsDSP.page === 1 ? newOptions : [...prev, ...newOptions];
        setHasMoreDSP(meta?.total > combined?.length);
        return combined;
      });
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setLoadingFilter(false);
    }
  };
  const debounceFilterDSP = useCallback(
    debounce(() => {
      getOptionDSP();
    }, 500),
    [filterParamsDSP]
  );
  const getOptionPeriod = async () => {
    setLoadingFilter(true);
    try {
      const res = await axios.get(`${hardBaseUrl}/potential-claim/periods`, {
        headers,
        params: filterParamsPeriod,
      });
      const { data, meta } = res?.data;
      const newOptions = data?.map(item => ({
        ...item,
        header_ids: arrayToCommaSeparatedString(item?.header_ids),
      }));
      setOptionProcessInfo(prev => {
        const combined =
          filterParamsPeriod.page === 1
            ? [
                createAllFilterOption({ key: "header_ids", label: "name" }),
                ...newOptions,
              ]
            : [...prev, ...newOptions];
        setHasMorePeriod(meta?.total > combined.length - 1);
        if (
          selectedProcessInfo.length > 0 &&
          selectedProcessInfo.some(item => item?.header_ids === "all")
        ) {
          setSelectedProcessInfo(combined);
          handleChangeQueryParams(
            arrayToCommaSeparatedString(
              combined.filter(item => item?.header_ids !== "all"),
              "header_ids"
            ),
            "header_ids"
          );
        }
        return combined;
      });
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setLoadingFilter(false);
    }
  };
  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [getDetail(), getDataTable()];

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
    }
  };
  const handlePreviewClaim = async (
    trigger,
    selectedSongs,
    params,
    paramsPreview
  ) => {
    const { dsp_id, header_ids, matching_key } = params;
    const formattedSongs = selectedSongs.map(item => {
      const hasSelected = item.selected_record_ids?.length > 0;
      const hasNotSelected = item.not_selected_record_ids?.length > 0;

      if (!hasSelected && !hasNotSelected) {
        return { song_id: item.song_id };
      }
      return {
        song_id: item.song_id,
        ...(hasSelected && {
          selected_record_ids: item.selected_record_ids,
        }),
        ...(hasNotSelected && {
          not_selected_record_ids: item.not_selected_record_ids,
        }),
      };
    });
    const modifiedPayload = {
      dsp_id: dsp_id,
      header_ids: header_ids?.split(",").map(Number) || [],
      matching_key: matching_key === 0 ? "" : matching_key,
      songs: formattedSongs,
      ...paramsPreview,
    };

    try {
      setLoadingPage(true);
      setLoadingPreview(true);
      const res = await axios.post(
        `${hardBaseUrl}/potential-claim/preview-claim`,
        modifiedPayload,
        { headers }
      );
      const { data, meta } = res?.data;
      setPreviewDetails(data);
      const pageCount = getTotalPage(meta?.total, queryParamsPreview?.per_page);
      setTablePreviewPageCount(pageCount || 1);
      if (trigger) {
        setModalPreviewVisible(true);
      }
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setLoadingPreview(false);
      setLoadingPage(false);
    }
  };
  const debounceDataPreview = useMemo(
    () =>
      debounce(() => {
        handlePreviewClaim(
          false,
          selectedSongRef.current,
          paramsRef.current,
          previewParamsRef.current
        );
      }, 500),
    []
  );
  const handleDownloadDocuments = async () => {
    const { dsp_id, header_ids, matching_key, search, sort } = queryParams;
    setLoadingDownloadButton(true);
    try {
      const res = await axios.get(
        `${hardBaseUrl}/potential-claim/matched-songs/download`,
        {
          headers,
          params: {
            dsp_id,
            header_ids,
            matching_key: matching_key === 0 ? "" : matching_key,
            search,
            sort,
          },
        }
      );
      setModalVisible(false);
      ModalSuccess(res?.data?.data).then(() =>
        history.push("/admin/download-monitoring")
      );
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setLoadingDownloadButton(false);
    }
  };
  const handleDragFiles = async acceptedFiles => {
    const payloadInit = { filenames: acceptedFiles?.map(item => item?.path) };
    try {
      const res = await axios.post(
        `${hardBaseUrl}/storage/upload/init`,
        payloadInit,
        { headers }
      );
      const uploadData = res?.data?.data || [];
      setCloudFiles(uploadData);

      await Promise.all(
        uploadData.map((item, index) => {
          const file = acceptedFiles[index];

          return axios.put(item.url, file, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": file.type,
            },
          });
        })
      );
    } catch (error) {
      ModalError(getErrors(error));
    }
  };
  const handleUploadImportClaim = async acceptedFiles => {
    const localFiles = { filenames: acceptedFiles?.map(item => item?.name) };
    const filteredFiles = cloudFiles?.filter(tempFile =>
      localFiles?.filenames?.includes(tempFile?.original_name)
    );
    const payload = {
      dsp_id: queryParams?.dsp_id,
      files: filteredFiles.map(file => ({
        original_name: file.original_name,
        filename: file.filename,
      })),
    };

    setLoadingButton(true);
    try {
      await axios.post(`${hardBaseUrl}/potential-claim/claim/import`, payload, {
        headers,
      });
      ModalSuccess("Successfully Import Claim").then(() =>
        history.push("/admin/publisher/potential-claim-log")
      );
    } catch (error) {
      ModalError(getErrors(error));
    } finally {
      setLoadingButton(false);
    }
  };
  const handleAgreement = async () => {
    try {
      await axios.post(
        `${hardBaseUrl}/potential-claim/approve-disclaimer`,
        {},
        { headers }
      );
    } catch (error) {
      ModalError(getErrors(error));
    }
  };

  useEffect(() => {
    ModalAgreementPotentialClaim({
      onAgree: handleAgreement,
      onDisagree: () => history.goBack(),
    });
  }, []);
  useEffect(() => {
    const isSearching = Boolean(filterParamsDSP?.search);
    if (isSearching) {
      debounceFilterDSP();
      return () => {
        debounceFilterDSP.cancel();
      };
    } else {
      getOptionDSP();
    }
  }, [filterParamsDSP]);
  useEffect(() => {
    if (queryParams?.dsp_id) {
      getOptionPeriod();
    }
  }, [filterParamsPeriod]);
  useEffect(() => {
    if (!queryParams?.dsp_id) {
      resetFilter();
    }
  }, [queryParams?.dsp_id]);
  useEffect(() => {
    if (queryParams?.dsp_id && queryParams?.header_ids) {
      const isSearching = Boolean(queryParams?.search);
      if (isSearching) {
        debounceDataTable();
        return () => {
          debounceDataTable.cancel();
        };
      } else {
        fetchData();
      }
    } else {
      setDataTable([]);
      setPageDetail({});
    }
  }, [queryParams, debounceDataTable]);
  useEffect(() => {
    if (queryParams?.dsp_id && queryParams?.header_ids) {
      getDataChildrenTable();
    } else {
      setDataTableChildren([]);
    }
  }, [queryParamsChildren]);
  useEffect(() => {
    if (!queryParams.dsp_id || !queryParams.header_ids) {
      return;
    }

    if (skipNextPreviewRef.current) {
      skipNextPreviewRef.current = false;
      return;
    }

    const isSearching = Boolean(queryParamsPreview.search);

    if (isSearching) {
      debounceDataPreview();
      return () => debounceDataPreview.cancel();
    }

    handlePreviewClaim(false, selectedSong, queryParams, queryParamsPreview);
  }, [queryParamsPreview, selectedSong, debounceDataPreview]);
  useEffect(() => {
    selectedSongRef.current = selectedSong;
  }, [selectedSong]);
  useEffect(() => {
    paramsRef.current = queryParams;
  }, [queryParams]);
  useEffect(() => {
    previewParamsRef.current = queryParamsPreview;
  }, [queryParamsPreview]);

  return (
    <Page className={classes?.root} title={pageTitle}>
      <Container maxWidth={false}>
        <HeaderTitle
          title={pageTitle}
          breadcrumbData={breadcrumbData({ pageTitle })}
        />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <FormCard bgcolor="#F9FAFB" px={2} py={4}>
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormLabel label="DSP" />
              <AutoCompleteWithSearch
                placeholder="DSP"
                options={optionDSP}
                value={
                  optionDSP?.find(
                    option => option?.id === Number(queryParams?.dsp_id)
                  ) || null
                }
                optionLabel="dsp_name"
                onChange={val => {
                  const dsp_id = val?.dsp_id || 0;
                  handleChangeQueryParams(dsp_id, "dsp_id");
                  handleChangeFilterParamsPeriod(dsp_id, "dsp_id");
                }}
                inputValue={filterParamsDSP?.search}
                isOptionEqualToValue={(option, value) =>
                  option?.dsp_id === value?.dsp_id
                }
                uniqueKey="id"
                onInputChange={e => handleChangeFilterParamsDSP(e, "search")}
                setQueryParams={setfilterParamsDSP}
                hasMore={hasMoreDSP}
                loading={loadingFilter}
                disabled={loadingPage}
                width="100%"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormLabel label="Period" />
              <MultipleSelectInput
                placeholder="Period"
                value={selectedProcessInfo}
                textValue={
                  selectedProcessInfo.length > 0 &&
                  selectedProcessInfo.some(item => item?.header_ids === "all")
                    ? "All"
                    : selectedProcessInfo
                        ?.map(item => item?.period)
                        ?.join(", ") || ""
                }
                options={optionProcessInfo}
                optionKey="header_ids"
                onChange={handleChangeFilterProcessInfo}
                checkBoxLabel={item =>
                  optionProcessInfo?.length
                    ? item?.header_ids === "all"
                      ? "All"
                      : `${item?.period}`
                    : null
                }
                disabled={loadingPage || loadingFilter}
                width="100%"
                hasMore={hasMorePeriod}
                setQueryParams={setFilterParamsPeriod}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormLabel label="Search" />
              <SearchTextInput
                placeholder="Search"
                value={queryParams?.search}
                onChange={e =>
                  handleChangeQueryParams(e.target.value, "search")
                }
                disabled={loadingPage || loadingFilter}
                width="100%"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormLabel label="Matching Key" />
              <SelectInput
                value={queryParams?.matching_key}
                onChange={e => {
                  handleChangeQueryParams(e?.target?.value, "matching_key");
                }}
                options={optionsMatchingKey}
                optionKey="value"
                optionLabel="label"
                disabled={loadingPage || loadingFilter}
                width="100%"
              />
            </Grid>
          </Grid>
        </FormCard>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <InformationCard pageDetail={pageDetail} isLoadiing={loadingPage} />
          </Grid>
          <Grid item>
            <Grid container columnGap={1}>
              <Grid item>
                <PrimaryButton
                  label="Import Claim"
                  onClick={() => setModalVisible(true)}
                  disabled={
                    loadingPage ||
                    loadingFilter ||
                    !queryParams?.dsp_id ||
                    !queryParams?.header_ids
                  }
                />
              </Grid>
              <Grid item>
                <PrimaryButton
                  label="Submit Claim"
                  onClick={() =>
                    handlePreviewClaim(
                      true,
                      selectedSong,
                      queryParams,
                      queryParamsPreview
                    )
                  }
                  disabled={
                    loadingPage || loadingFilter || selectedSong?.length === 0
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable || []}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tablePageCount}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          sortValue={queryParams?.sort}
          onRequestSort={sortBy =>
            handleChangeQueryParams(
              `${sortBy} ${
                queryParams.sort === `${sortBy} asc` ? "desc" : "asc"
              }`,
              "sort"
            )
          }
          isHaveCheckbox
          checked={item =>
            selectedSong?.some(selected => selected?.song_id === item?.song_id)
          }
          handleCheckbox={handleSelectSong}
          disabledCheckbox={item => item?.is_over_claim}
          isExpandable
          expandedRowKey="id"
          handleExpandableRow={item =>
            handleChangeQueryParamsChildren(item?.song_id, "song_id")
          }
          renderExpandedRow={() => (
            <CustomTable
              isLoading={loadingChildrenTable}
              columnTable={columnTableChildren}
              data={dataTableChildren || []}
              page={queryParamsChildren?.page}
              pageSize={queryParamsChildren?.size}
              pageCount={tablePageCountChildren}
              handleChangePage={(_, page) =>
                handleChangeQueryParamsChildren(page, "page")
              }
              handleChangePageSize={e =>
                handleChangeQueryParamsChildren(e?.target?.value, "size")
              }
              isHaveCheckbox
              handleCheckbox={handleSelectChildSong}
              disabledCheckbox={item => item?.is_over_claim}
              checked={item => {
                const parent = selectedSong?.find(
                  p => p.song_id === queryParamsChildren?.song_id
                );

                if (!parent) return false;

                const isSelectAllMode = parent.selected_record_ids.length === 0;

                if (isSelectAllMode) {
                  return !parent.not_selected_record_ids.includes(item.id);
                }

                return parent.selected_record_ids.includes(item.id);
              }}
              sortValue={queryParamsChildren?.sort}
              onRequestSort={sortBy =>
                handleChangeQueryParamsChildren(
                  `${sortBy} ${
                    queryParamsChildren.sort === `${sortBy} asc`
                      ? "desc"
                      : "asc"
                  }`,
                  "sort"
                )
              }
              maxHeight={300}
              tableSize="small"
            />
          )}
          mt={2}
        />
      </Container>
      {modalVisible && (
        <ImportDocumentModal
          modalTitle="Import Claim"
          open={modalVisible}
          onClose={() => setModalVisible(false)}
          loadingButton={loadingButton}
          fileType=".xlsx, .xls"
          handleDownloadButton={handleDownloadDocuments}
          loadingDownloadButton={loadingDownloadButton}
          handleDragFiles={handleDragFiles}
          multiple
          onSubmit={handleUploadImportClaim}
        />
      )}
      {modalPreviewVisible && (
        <ModalPreviewPotentialClaim
          open={modalPreviewVisible}
          onClose={handleCloseModalPreview}
          loadingPage={loadingPreview}
          setLoadingPage={setLoadingPreview}
          pageDetail={previewDetails}
          queryParamsPreview={queryParamsPreview}
          tableTotalPage={tablePreviewPageCount}
          setQueryParamsPreview={setQueryParamsPreview}
          queryParams={queryParams}
          selectedSong={selectedSong}
          setSelectedSong={setSelectedSong}
        />
      )}
    </Page>
  );
};
export const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Potential Claim",
    link: "/admin/publisher/potential-claim",
  },
  {
    label: pageTitle,
    active: true,
  },
];
const optionsMatchingKey = [
  { value: 0, label: "All" },
  { value: "title-low", label: "Song Title Low" },
  { value: "title-medium", label: "Song Title Medium" },
  { value: "title-high", label: "Song Title High" },
];
const columnTable = [
  {
    name: "all",
    title: "Song Title",
    sort_key: "title",
    useSort: true,
    renderText: item => (
      <Box>
        {item?.song_title}
        {item?.is_over_claim && (
          <Typography fontSize="10px" color="red">
            This Song is Overclaimed
          </Typography>
        )}
      </Box>
    ),
  },
  {
    name: "composer",
    title: "Composer/Author",
    renderText: item => {
      const composers = item?.split("|");
      return <ArrayChip list={composers} />;
    },
  },
  {
    name: "traffic",
    title: "Traffic",
    headerAlign: "right",
    sort_key: "traffic",
    useSort: true,
    renderText: item => <CurrencyDisplay value={item} />,
  },
  {
    name: "revenue",
    title: "Revenue",
    headerAlign: "right",
    sort_key: "revenue",
    useSort: true,
    renderText: item => <CurrencyDisplay value={item} prefix="Rp" />,
  },
  {
    name: "matched_count",
    title: "Song Matched",
    renderText: item => <StatusChip type="success" label={item} />,
  },
];
const columnTableChildren = [
  {
    name: "song_title",
    title: "Song Title",
    sort_key: "title",
    useSort: true,
  },
  {
    name: "composer",
    title: "Composer/Author",
    renderText: item => {
      const composers = item?.split("|");
      return <ArrayChip list={composers} />;
    },
  },
  {
    name: "isrc",
    title: "ISRC",
  },
  {
    name: "traffic",
    title: "Traffic",
    headerAlign: "right",
    sort_key: "traffic",
    useSort: true,
    renderText: item => <CurrencyDisplay value={item} />,
  },
  {
    name: "revenue",
    title: "Revenue",
    headerAlign: "right",
    sort_key: "revenue",
    useSort: true,
    renderText: item => <CurrencyDisplay value={item} prefix="Rp" />,
  },
  {
    name: "matching_key",
    title: "Matching Key",
    renderText: item =>
      optionsMatchingKey?.find(option => option?.value === item)?.label || item,
  },
];
export default PotentialClaim;
